import { type AppDisplay, VCS_APP_DISPLAY } from '../../../../../shared/vcs/githubApp/apps';
import Button from '../../../generic/Button/Button';
import { BUTTON_SIZE, BUTTON_TYPE } from '../../../generic/Button/button-constants';
import Flex from '../../../generic/Flex';
import { redirectToGithubAppInstallation } from '../utils';

import styles from './Fallback.module.less';

type Props = {
  /**
   * Install action for the CTA. Defaults to the legacy GitHub App install popup; the
   * vcs-service import flow passes its own handler.
   */
  onInstall?: () => void;
  /**
   * Name + logo shown in the CTA. Defaults to generic FOSSA branding; the vcs-service
   * flow passes the specific app's display data (e.g. fossabot).
   */
  appDisplay?: AppDisplay;
};

const InstallGithubAppFallback = ({
  onInstall = redirectToGithubAppInstallation,
  // fossaCore's display is the generic "FOSSA app" branding
  // it's the default shown when no specific app is passed (e.g. the legacy import flow)
  appDisplay = VCS_APP_DISPLAY.fossaCore,
}: Props) => {
  // fossabot is the upgraded app, so it gets the migration-specific pitch; every other app gets the plain one
  const isFossabot = appDisplay.name === VCS_APP_DISPLAY.fossabot.name;

  return (
    <div className={styles.fallback}>
      <Flex gap="8px" direction="column">
        <img src={appDisplay.logo} alt={appDisplay.name} width="64px" />
        <div className={styles.title}>Install the {appDisplay.name} app</div>
        <div className={styles.description}>
          Install the {appDisplay.name} app on your GitHub organization to continue.
        </div>
        <div className={styles.description}>
          {isFossabot
            ? 'This upgraded GitHub app includes the permissions needed to create Auto PRs with fossabot and other new features, and replaces the previous app for these workflows.'
            : 'It gives FOSSA the permissions needed to list your repositories and import them here.'}
        </div>
      </Flex>
      <Button type={BUTTON_TYPE.PRIMARY} size={BUTTON_SIZE.MEDIUM} onClick={onInstall}>
        Install App
      </Button>
    </div>
  );
};

export default InstallGithubAppFallback;
